<template>
    <div>
        <!-- 简介介绍 -->
        <van-popup v-model="contShow" close-icon-position="top" position="top" :style="{ height: '100%' }">
            <!-- 顶部 -->
            <div class="videoAll-top">
                <div class="video_name" @click="showPopup">
                    <div class="live-title">{{baseList.livename}}</div>
                    <div class="live-photo">
                        <img src="../../../assets/videoImg/shouqi.png" alt="" />
                    </div>
                </div>
                <div class="video_more">{{baseList.viewcount}}人次观看</div>
                <div class="video_Introduction">
                    <div class="touxiang" @click="companyFun(company_data)" v-if="company_data.organ_id>0">
                        <div style="width: 1.5rem; height: 1.5rem;float:left;position:relative;">
                            <!-- <img style="width: 100%; height: 100%; border-radius: 1.25rem;" src="@/assets/videoImg/tx.jpg" alt=""/> -->
                            <img style="width: 100%; height: 100%; border-radius: 1.25rem;" :src="company_data.headpic" alt=""/>
                            <!-- <img style="width:0.5rem;height:0.5rem;position:absolute;right:0px;bottom:0px;z-index:99;" src="../../../assets/videoImg/bq.png" alt="" /> -->
                        </div>
                        <div style="font-size: 0.7rem; color: #ffffff; padding-left: 10px;float:left;line-height:1.5rem;">{{company_data.name}}</div>
                    </div>
                </div>
            </div>
            <!-- 文字介绍内容 -->
            <div class="jiesaoBox">
                <div class="jiesao" v-if="baseList.context!=undefined&&baseList.context!=''&&baseList.context!=null">
                    简介：<br/>{{baseList.context}}
                </div>
                <div class="jiesao" v-if="baseList.auction_schedule!=undefined&&baseList.auction_schedule!=''&&baseList.auction_schedule!=null">
                    拍卖日程：<br/>{{baseList.auction_schedule}}<br/>
                </div>
                <div class="zhuci">
                    <div class="zhuci_list" v-if="baseList.host!=undefined&&baseList.host!=''&&baseList.host!=null">
                        <div class="zhuci_list1">主持人：</div>
                        <div class="zhuci_list2">{{baseList.host}}</div>
                    </div>
                    <div class="zhuci_list" v-if="baseList.speaker!=undefined&&baseList.speaker!=''&&baseList.speaker!=null">
                        <div class="zhuci_list1">主讲人：</div>
                        <div class="zhuci_list2">{{baseList.speaker}}</div>
                    </div>
                    <div class="zhuci_list" v-if="baseList.guest!=undefined&&baseList.guest!=''&&baseList.guest!=null">
                        <div class="zhuci_list1">嘉宾：</div>
                        <div class="zhuci_list2">{{baseList.guest}}</div>
                    </div>
                    <div class="zhuci_list" v-if="baseList.sponsor!=undefined&&baseList.sponsor!=''&&baseList.sponsor!=null">
                        <div class="zhuci_list1">主办方：</div>
                        <div class="zhuci_list2">{{baseList.sponsor}}</div>
                    </div>
                    <div class="zhuci_list" v-if="baseList.contractor!=undefined&&baseList.contractor!=''&&baseList.contractor!=null">
                        <div class="zhuci_list1">承办方：</div>
                        <div class="zhuci_list2">{{baseList.contractor}}</div>
                    </div>
                    <div class="zhuci_list" v-if="baseList.cosponsor!=undefined&&baseList.cosponsor!=''&&baseList.cosponsor!=null">
                        <div class="zhuci_list1">协办方：</div>
                        <div class="zhuci_list2">{{baseList.cosponsor}}</div>
                    </div>
                    <div class="zhuci_list" v-if="baseList.cooperative!=undefined&&baseList.cooperative!=''&&baseList.cooperative!=null">
                        <div class="zhuci_list1">合作机构：</div>
                        <div class="zhuci_list2">{{baseList.cooperative}}</div>
                    </div>
                    <div class="zhuci_list" v-if="baseList.address!=undefined&&baseList.address!=''&&baseList.address!=null">
                        <div class="zhuci_list1">地址：</div>
                        <div class="zhuci_list2">{{baseList.address}}</div>
                    </div>
                </div>
            </div>
            <!-- 底部收起 -->
            <div class="video-icon" @click="showPopup">
                <van-icon name="arrow-up" size="1.2rem" color="#FFFFFF" />
                <div class="video-pickup">收起</div>
            </div>
        </van-popup>
    </div>
</template>

<script>
export default {
    props:["synopsisShow","liveData"],
    data() {
        return {
            contShow: this.synopsisShow, //显示
            liveDatas:'',//数据
            company_data:'',//拍卖机构信息
            baseList:'',//基础
        };
    },
    methods: {
        // 关闭
        contClick() {
            this.contShow = false;
        },
        synopsisFun(show,liveData){
            this.contShow=show;
            this.liveDatas=liveData;
            this.company_data=liveData.company_data;
            this.baseList=liveData.baseList;
        },
        showPopup() {
            this.contShow = !this.contShow;
        },
        companyFun(item){//拍卖公司
            if(item.organ_code!=''){
                if(this.watermarkShow==true){//有水印
                    window.location.href = 'https://m-auction.artron.net/organ/'+item.organ_code+'?from=2&fromlink='+encodeURIComponent(window.location.href);
                }else{//无水印
                    window.location.href = 'https://m-auction.artron.net/organ/'+item.organ_code+'?fromlink='+encodeURIComponent(window.location.href);
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
/deep/ .van-popup--top {
    color:#fff;
    background: rgba(0, 0, 0, 0.3);
    padding:0.6rem;
}
.video_name{    
    float:left;
    max-width: 12rem;
}
.live-title {
    width:auto;
    max-width: 10rem;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    float:left;
    font-size:0.9rem;
}
.live-photo{
    float:left;
    margin-top:0.2rem;
}
.video_more{
    height: 1.5rem;
    padding: 0px 0.6rem;
    font-size: 0.6rem;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    background: rgba(16, 16, 16, 0.6);
    border-radius: 0.75rem;
    color: #ffffff;
    float:right;
}
.video_Introduction{
    width:100%;
    float:left;
    overflow:hidden;
    margin:0.8rem 0rem 1rem;
}
.jiesaoBox{
    width:100%;
    max-height: 74%;
    overflow-x:hidden;
    overflow-y:scroll;
}
.jiesao{
    width:100%;
    line-height: 1.2rem;
    font-size:0.7rem;
    overflow:hidden;
    padding:0.2rem 0rem;
}
.zhuci{
    width:100%;
    height:auto;
}
.zhuci_list{
    width:100%;
    height:auto;
    overflow:hidden;
    padding:0.6rem 0rem 0rem;
    line-height:1.2rem;
    border-bottom:1px solid #5A5A5A;
    padding-bottom:0.8rem;
}
.zhuci_list:last-child{
    border-bottom:0px;
}
.zhuci_list1{
    width:100%;
}
.zhuci_list2{
    width:100%;
}
.video-icon{
    width:100%;
    position:absolute;
    bottom:1rem;
    left:0px;
    z-index:999;
    text-align:center;
}
</style>